import React from 'react';
// @ts-ignore
import styles from './EPrescriptionMedicamentsList.module.scss';
import EPrescriptionMedicamentsListItem from './EPrescriptionMedicamentsListItem';
import { EPrescriptionMedicament } from './EPrescriptionMedicamentsWrapper';

interface EPrescriptionMedicamentsListProps {
	medicaments: EPrescriptionMedicament[];
	onRemove: (item: EPrescriptionMedicament) => void;
	onEdit: (item: EPrescriptionMedicament) => void;
}

const EPrescriptionMedicamentsList: React.FC<
	EPrescriptionMedicamentsListProps
> = ({ medicaments, onRemove, onEdit }) => {
	return (
		<div className={styles.wrapper}>
			{medicaments.map((item, index) => {
				return (
					<React.Fragment key={index}>
						<EPrescriptionMedicamentsListItem
							item={item}
							onRemove={onRemove}
							onEdit={onEdit}
						/>
					</React.Fragment>
				);
			})}
		</div>
	);
};

export default EPrescriptionMedicamentsList;
